import type { FunctionComponent } from 'react';
import { useCallback } from 'react';

import { CalendarIcon } from '@trello/nachos/icons/calendar';
import { usePopover } from '@trello/nachos/popover';
import type { QuickCardEditorTestIds } from '@trello/test-ids';
import { getTestId } from '@trello/test-ids';

import { LazyAddCardToPlannerPopover } from 'app/src/components/Planner/AddCardToPlannerPopover/LazyAddCardToPlannerPopover';
import { QuickCardEditorButton } from './QuickCardEditorButton';

interface AddCardToPlannerButtonProps {
  onClose: () => void;
}

export const AddCardToPlannerButton: FunctionComponent<
  AddCardToPlannerButtonProps
> = ({ onClose }) => {
  const { popoverProps, toggle, triggerRef } = usePopover();

  const onClick = useCallback(() => {
    toggle();
  }, [toggle]);

  return (
    <>
      <QuickCardEditorButton
        icon={<CalendarIcon size="small" />}
        onClick={onClick}
        ref={triggerRef}
        testId={getTestId<QuickCardEditorTestIds>(
          'quick-card-editor-add-card-to-planner',
        )}
        isSelected={popoverProps.isVisible}
        aria-expanded={popoverProps.isVisible}
      >
        Schedule focus time
      </QuickCardEditorButton>

      {popoverProps.isVisible && (
        <LazyAddCardToPlannerPopover
          popoverProps={popoverProps}
          onClose={onClose}
        />
      )}
    </>
  );
};
